<template>
    <v-card
        style="border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important"
        class="default_card_wm elevation-0 pa-2 mb-4"
        v-if="showSummaryPanel"
    >
        <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-center" v-if="noVat && !vatAmountToRemove">
                <v-alert
                    border="start"
                    width="90%"
                    color="warning"
                    icon="$warning"
                    :model-value="true"
                    variant="text"
                >
                    Pas de TVA à déclarer
                </v-alert>
            </v-col>
            <template v-else>
                <v-col cols="12" class="mx-2 my-2 pr-4 d-flex justify-space-between align-center">
                    <h3>Récapitulatif</h3>
                    <v-btn size="small" @click="showSummaryPanelAction()" v-if="showSummaryPanel"
                        >Masquer</v-btn
                    >
                </v-col>
                <v-col
                    cols="12"
                    v-if="
                        totalCollVat.totalBase ||
                        totalPurchasesIntracomBase ||
                        totalImportBase ||
                        totalReverseChargeBase
                    "
                >
                    <v-list-item class="mb-2 py-2 rounded-xl border">
                        <v-list-item-title
                            class="body-1 font-weight-bold"
                            style="font-size: 0.875em"
                        >
                            <v-row>
                                <v-col cols="12"> Opérations taxées : </v-col>
                            </v-row>
                            <v-row v-if="totalCollVat.totalBase">
                                <v-col cols="9">Ventes, services :</v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat.totalBase)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="totalImportBase">
                                <v-col cols="9"> Importations : </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalImportBase)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="totalPurchasesIntracomBase">
                                <v-col cols="9" class="text-truncate">
                                    Acquisitions intracommunautaires :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalPurchasesIntracomBase)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="totalReverseChargeBase">
                                <v-col cols="9" class="text-truncate">
                                    Autres opérations imposables :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalReverseChargeBase)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </v-col>
                <v-col
                    cols="12"
                    v-if="totalExportBase || totalNonTaxableBase || totalSalesIntracomBase"
                >
                    <v-list-item class="mb-2 py-2 rounded-xl border">
                        <v-list-item-title
                            class="body-1 font-weight-bold"
                            style="font-size: 0.875em"
                        >
                            <v-row>
                                <v-col cols="12"> Opérations non taxées : </v-col>
                            </v-row>
                            <v-row v-if="totalExportBase">
                                <v-col cols="9">Exportations hors UE :</v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalExportBase)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="totalNonTaxableBase">
                                <v-col cols="9" class="text-truncate"
                                    >Autres opérations non imposables :</v-col
                                >
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalNonTaxableBase)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="totalSalesIntracomBase">
                                <v-col cols="9" class="text-truncate"
                                    >Livraisons intracommunautaires :</v-col
                                >
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalSalesIntracomBase)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </v-col>
                <v-col
                    cols="12"
                    v-if="
                        totalCollVat.totalBase ||
                        totalCollVat.totalCollIntracom ||
                        totalCollVat.grandTotal
                    "
                >
                    <v-list-item class="mb-2 py-2 rounded-xl border">
                        <v-list-item-title
                            class="body-1 font-weight-bold"
                            style="font-size: 0.875em"
                        >
                            <v-row no-gutters class="mb-2">
                                <v-col cols="12"> TVA brute : </v-col>
                            </v-row>
                            <v-row no-gutters class="mb-1" v-if="totalCollVat[2.1].net">
                                <v-col cols="2" class="d-flex justify-start"> 2,1 % : </v-col>
                                <v-col cols="5" class="d-flex justify-start">
                                    HT :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[2.1].net)),
                                        )
                                    }}
                                </v-col>
                                <v-col cols="5" class="d-flex justify-end">
                                    TVA :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[2.1].vat)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mb-1" v-if="totalCollVat[5.5].net">
                                <v-col cols="2" class="d-flex justify-start"> 5,5 % : </v-col>
                                <v-col cols="5" class="d-flex justify-start">
                                    HT :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[5.5].net)),
                                        )
                                    }}
                                </v-col>
                                <v-col cols="5" class="d-flex justify-end">
                                    TVA :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[5.5].vat)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mb-1" v-if="totalCollVat[8.5].net">
                                <v-col cols="2" class="d-flex justify-start"> 8,5 % : </v-col>
                                <v-col cols="5" class="d-flex justify-start">
                                    HT :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[8.5].net)),
                                        )
                                    }}
                                </v-col>
                                <v-col cols="5" class="d-flex justify-end">
                                    TVA :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[8.5].vat)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mb-1" v-if="totalCollVat[10].net">
                                <v-col cols="2" class="d-flex justify-start"> 10 % : </v-col>
                                <v-col cols="5" class="d-flex justify-start">
                                    HT :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[10].net)),
                                        )
                                    }}
                                </v-col>
                                <v-col cols="5" class="d-flex justify-end">
                                    TVA :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[10].vat)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mb-1" v-if="totalCollVat[20].net">
                                <v-col cols="2" class="d-flex justify-start"> 20 % : </v-col>
                                <v-col cols="5" class="d-flex justify-start">
                                    HT :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[20].net)),
                                        )
                                    }}
                                </v-col>
                                <v-col cols="5" class="d-flex justify-end">
                                    TVA :
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat[20].vat)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mt-3" v-if="totalCollVat.grandTotal">
                                <v-col cols="9" class="d-flex justify-start">
                                    Total TVA brute due :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat.grandTotal)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mt-1" v-if="totalCollVat.totalCollIntracom">
                                <v-col cols="9" class="text-truncate">
                                    Dont TVA/acquisitions intracommunautaires :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalCollVat.totalCollIntracom)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </v-col>
                <v-col cols="12">
                    <v-list-item class="mb-2 py-2 rounded-xl border">
                        <v-list-item-title
                            class="body-1 font-weight-bold"
                            style="font-size: 0.875em"
                        >
                            <v-row :style="{ color: totalDedVat.grandTotal < 0 && 'red' }">
                                <v-col cols="9"> TVA déductible : </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        previousVatCredit?.vatAmount
                                            ? formatCurrencyWithoutDecimals(
                                                  Math.round(
                                                      totalDedVat.grandTotal +
                                                          previousVatCredit.vatAmount,
                                                  ),
                                              )
                                            : formatCurrencyWithoutDecimals(
                                                  Math.round(totalDedVat.grandTotal),
                                              )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="totalDedVat.totalDedFixedAssets">
                                <v-col cols="9" class="text-truncate">
                                    Dont TVA sur immobilisations :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalDedVat.totalDedFixedAssets)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="9" class="text-truncate">
                                    Dont TVA sur autres biens et services :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.round(
                                                totalDedVat.grandTotal -
                                                    totalDedVat.totalDedFixedAssets -
                                                    totalDedVat.totalDedImport,
                                            ),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="totalDedVat.totalDedImport">
                                <v-col cols="9" class="text-truncate">
                                    Dont TVA sur importations :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalDedVat.totalDedImport)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                            <v-row v-if="previousVatCredit">
                                <v-col cols="9" class="text-truncate">
                                    Dont crédit période précédente :
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(previousVatCredit.vatAmount),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </v-col>
                <v-col cols="12" v-if="vatAmountToRemove">
                    <v-list-item class="mb-2 py-2 rounded-xl border">
                        <v-list-item-title
                            class="body-1 font-weight-bold"
                            style="font-size: 0.875em"
                        >
                            <v-row no-gutters>
                                <v-col cols="9" class="text-truncate">
                                    Total à déclarer plus tard
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(vatAmountToRemove)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </v-col>
                <v-col cols="12">
                    <v-list-item class="mb-2 py-2 rounded-xl border">
                        <v-list-item-title
                            class="body-1 font-weight-bold"
                            style="font-size: 0.875em"
                        >
                            <v-row no-gutters>
                                <v-col cols="9">
                                    {{ totalVat <= 0 ? "Crédit de TVA" : "Total à décaisser" }}
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end">
                                    {{
                                        formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(totalVat)),
                                        )
                                    }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </v-col>
            </template>
        </v-row>
    </v-card>
</template>

<script lang="ts">
import { formatCurrencyWithoutDecimals } from "../../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import {
    VatItemAuto,
    VatItemAssist,
} from "../../../../../backend/src/common/declaration/declarationServices";
import { PreviousVatCredit } from "../../../../../backend/src/common/types/taxformTypes";

@Component({ emits: ["show-summary-panel"] })
export class VATDeclarationSummaryCard extends Vue {
    @Prop({ default: [] }) autoVatItems: VatItemAuto[];
    @Prop({ default: [] }) assistVatItems: VatItemAssist[];
    @Prop({ default: null }) previousVatCredit: PreviousVatCredit;
    @Prop({ default: false }) noVat: boolean;
    @Prop({ default: true }) showSummaryPanel: boolean = true;

    get totalDedVat() {
        const total = {
            totalDedFixedAssets: 0,
            totalDedImport: 0,
            grandTotal: 0,
        };
        for (const item of this.assistVatItems) {
            if (item.toAdd && (item.type === "Déductible" || item.type === "Intracom")) {
                total.grandTotal += Math.abs(item.vatAmount);
            } else if (item.toAdd && item.type === "Import") {
                total.totalDedImport += Math.abs(item.vatAmount);
                total.grandTotal += Math.abs(item.vatAmount);
            }
        }
        for (const item of this.autoVatItems) {
            if (item.toAdd) {
                if (item.vatScheme === "Déductible" || item.vatScheme === "Acquisition intracom") {
                    total.grandTotal += item.totalVatToDeclare; // not Math.abs, can contain credit notes
                } else if (item.vatScheme === "Autoliquidation") {
                    total.grandTotal -= item.totalVatToDeclare;
                } else if (item.vatScheme === "Immobilisation") {
                    total.totalDedFixedAssets += item.totalVatToDeclare;
                    total.grandTotal += item.totalVatToDeclare;
                } else if (item.vatScheme === "Import") {
                    total.totalDedImport -= item.totalVatToDeclare;
                    total.grandTotal -= item.totalVatToDeclare;
                } else if (item.vatScheme === "Z de caisse") {
                    if (item.totalOutputVat) {
                        total.grandTotal += item.totalOutputVat;
                    }
                }
            }
        }
        return total;
    }

    get totalPurchasesIntracomBase() {
        let total = 0;
        for (const item of this.assistVatItems) {
            if (item.toAdd && item.type === "Intracom") {
                total += Math.abs(item.netAmount);
            }
        }
        for (const item of this.autoVatItems) {
            if (item.toAdd && item.vatScheme === "Acquisition intracom") {
                total += item.totalGrossAmountSigned;
            }
        }
        return total;
    }

    get totalSalesIntracomBase() {
        let total = 0;
        for (const item of this.autoVatItems) {
            if (item.toAdd && item.vatScheme === "Livraison intracom") {
                total += item.totalGrossAmountSigned;
            } else if (item.toAdd && item.vatScheme === "Z de caisse") {
                for (const detail of item.details) {
                    for (const vat of detail.vats) {
                        if (vat.rate === 0 && vat.netAmountSigned < 0) total -= vat.netAmountSigned;
                    }
                }
            }
        }
        return total;
    }

    get totalReverseChargeBase() {
        let total = 0;
        for (const item of this.autoVatItems) {
            if (item.toAdd && item.vatScheme === "Autoliquidation") {
                total += item.totalGrossAmountSigned;
            }
        }
        return total;
    }

    get totalImportBase() {
        let total = 0;
        for (const item of this.assistVatItems) {
            if (item.toAdd && item.type === "Import") {
                total += Math.abs(item.netAmount);
            }
        }
        for (const item of this.autoVatItems) {
            if (item.toAdd && item.vatScheme === "Import") {
                total += item.totalGrossAmountSigned;
            }
        }
        return total;
    }

    get totalExportBase() {
        let total = 0;
        for (const item of this.assistVatItems) {
            if (item.toAdd && item.type === "Export") {
                total += Math.abs(item.netAmount);
            }
        }
        for (const item of this.autoVatItems) {
            if (!item.toAdd) {
                continue;
            }
            if (item.vatScheme === "Export") {
                total += item.totalGrossAmountSigned;
            }
            if (item.vatScheme === "Collectée") {
                total -= item.details?.reduce(
                    (acc, detail) =>
                        acc +
                        detail.vats
                            ?.filter((vat) => vat.rate === 0 && vat.vatDescription === "Export")
                            .reduce((sum, vat) => sum + vat.netAmountSigned, 0),
                    0,
                );
            }
        }
        return total;
    }

    get totalNonTaxableBase() {
        let total = 0;
        for (const item of this.autoVatItems) {
            if (!item.toAdd) {
                continue;
            }
            if (item.vatScheme === "Non imposable") {
                total += item.totalGrossAmountSigned;
            }
            if (item.vatScheme === "Collectée") {
                total -= item.details?.reduce(
                    (acc, detail) =>
                        acc +
                        detail.vats
                            ?.filter((vat) => vat.rate === 0 && !vat.vatDescription)
                            .reduce((sum, vat) => sum + vat.netAmountSigned, 0),
                    0,
                );
            }
        }
        return total;
    }

    get totalCollVat() {
        const total = {
            totalBase: 0,
            totalCollIntracom: 0,
            grandTotal: 0,
            2.1: {
                net: 0,
                vat: 0,
            },
            5.5: {
                net: 0,
                vat: 0,
            },
            8.5: {
                net: 0,
                vat: 0,
            },
            10: {
                net: 0,
                vat: 0,
            },
            20: {
                net: 0,
                vat: 0,
            },
        };
        for (const item of this.assistVatItems) {
            if (item.toAdd && item.type === "Collectée" && item.computedVatRate !== 0) {
                total[item.vatRate].vat += Math.abs(item.vatAmount);
                total[item.vatRate].net += Math.abs(item.netAmount);
                total.totalBase += Math.abs(item.netAmount);
                total.grandTotal += Math.abs(item.vatAmount);
            } else if (item.toAdd && item.type === "Import") {
                total[20].vat += Math.abs(item.vatAmount);
                total[20].net += Math.abs(item.netAmount);
                total.grandTotal += Math.abs(item.vatAmount);
            } else if (item.toAdd && item.type === "Intracom") {
                total[20].vat += Math.abs(item.vatAmount);
                total[20].net += Math.abs(item.netAmount);
                total.totalCollIntracom += Math.abs(item.vatAmount);
                total.grandTotal += Math.abs(item.vatAmount);
            }
        }
        for (const item of this.autoVatItems) {
            if (
                item.toAdd &&
                (item.vatScheme === "Collectée" || item.vatScheme === "Z de caisse")
            ) {
                for (const detail of item.details) {
                    for (const vat of detail.vats) {
                        if (
                            vat.rate &&
                            vat.rate > 0 &&
                            vat.vatAmountSigned &&
                            vat.netAmountSigned
                        ) {
                            total[vat.rate].vat -= vat.vatAmountSigned;
                            total[vat.rate].net -= vat.netAmountSigned;
                            total.totalBase -= vat.netAmountSigned;
                            total.grandTotal -= vat.vatAmountSigned;
                        }
                    }
                }
            } else if (
                item.toAdd &&
                (item.vatScheme === "Import" || item.vatScheme === "Autoliquidation")
            ) {
                total[20].vat -= item.totalVatToDeclare;
                total[20].net -= item.totalGrossAmountSigned;
                total.grandTotal += item.totalVatToDeclare;
            } else if (item.toAdd && item.vatScheme === "Acquisition intracom") {
                total[20].vat += item.totalVatToDeclare;
                total[20].net -= item.totalGrossAmountSigned;
                total.totalCollIntracom -= item.totalVatToDeclare;
                total.grandTotal += item.totalVatToDeclare;
            }
        }
        return total;
    }

    get totalVat() {
        const totalColl =
            Math.abs(this.totalCollVat[2.1].vat) +
            Math.abs(this.totalCollVat[5.5].vat) +
            Math.abs(this.totalCollVat[8.5].vat) +
            Math.abs(this.totalCollVat[10].vat) +
            Math.abs(this.totalCollVat[20].vat);
        if (this.previousVatCredit) {
            return totalColl - this.totalDedVat.grandTotal - this.previousVatCredit.vatAmount;
        }
        return totalColl - this.totalDedVat.grandTotal;
    }

    get vatAmountToRemove() {
        let total = 0.0;
        for (const vatItem of this.autoVatItems) {
            if (!vatItem.toAdd && vatItem.totalVatToDeclare) {
                total += vatItem.totalVatToDeclare;
            }
        }
        return total;
    }

    formatCurrencyWithoutDecimals(value) {
        return formatCurrencyWithoutDecimals(value);
    }

    showSummaryPanelAction() {
        this.$emit("show-summary-panel");
    }
}

export default toNative(VATDeclarationSummaryCard);
</script>
